import { Button, Grid, Typography } from '@material-ui/core';
import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import ImageBox from '~/components/ImageBox';
import useStyles from './CardGridSection.style';

const CardGridSection = (props) => {
  const classes = useStyles();
  const {
    background,
    title,
    subtitle,
    cards,
    descriptionStyle,
    imageStyle,
    columnCount = 3,
    handleLinkClick,
  } = props;

  const smCols = columnCount === 2 ? 6 : 4;
  return (
    <section style={{ background }} id={title}>
      <section className={classes.section}>
        <Typography variant='h4' className={classes.title} align='center'>
          {title}
        </Typography>
        {subtitle && (
          <Typography variant='subtitle1' className={classes.subtitleText} paragraph align='center'>
            {subtitle}
          </Typography>
        )}
        <Grid container spacing={5}>
          {cards.map((card, index) => (
            <Grid item xs={12} sm={smCols} key={index} className={classes.card}>
              <div>
                <ImageBox
                  fit='contain'
                  src={card.image.url}
                  alt={card.image.alt}
                  style={imageStyle}
                  width={card.image.width}
                  height={card.image.height}
                />
              </div>
              <Typography className={classes.cardHeading}>{card.heading}</Typography>
              <Typography className={classes.cardDescription} style={{ ...descriptionStyle }}>
                {card.description}
              </Typography>
              {card.link && (
                <Link href={card.link.url}>
                  <Button
                    className={classes.button}
                    variant='contained'
                    color='primary'
                    onClick={() => handleLinkClick(card.link)}>
                    {card.link.text}
                  </Button>
                </Link>
              )}
            </Grid>
          ))}
        </Grid>
      </section>
    </section>
  );
};

CardGridSection.propTypes = {
  /**
   * The background color of the section
   */
  background: PropTypes.string,
  /**
   * The title of the section
   */
  title: PropTypes.string.isRequired,
  /**
   * The subtitle of the section
   */
  subtitle: PropTypes.string,
  /**
   * Styling for the cards' descriptions
   */
  descriptionStyle: PropTypes.object,
  /**
   * Styling for the cards' images
   */
  imageStyle: PropTypes.object,
  /**
   * Click handler for cards' links
   */
  handleLinkClick: PropTypes.func,

  /**
   * Number of columns that you'd like (on wide screens)
   */
  columnCount: PropTypes.number,
  /**
   * Array of cards to display in the section
   */
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
      link: PropTypes.shape({
        text: PropTypes.string,
        url: PropTypes.string,
      }),
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
        height: PropTypes.number,
        width: PropTypes.number,
      }).isRequired,
    })
  ),
};

export default CardGridSection;
